import {TextField} from '@mui/material';
import React, {useState} from 'react';
import Spinner from 'react-activity/dist/Spinner';
import 'react-activity/dist/Spinner.css';
import {useNavigate} from 'react-router-dom';
import {useAddepar} from '../../hooks/use-adepar';
import {useBill} from '../../hooks/use-bill';
import {useBridge} from '../../hooks/use-bridge';
import {usePlaid} from '../../hooks/use-plaid';
import '../../styles/plaid.css';

export default function Dashboard({user}) {
  const navigate = useNavigate();

  const {
    state: {institutions, linking, accountsMissingInfo, accounts},
    addMissingInfo,
  } = usePlaid();
  const {
    state: {connection_ids, connections},
  } = useBill();
  const {
    state: {connection_ids: addepar_ids, connections: addepar_connections},
  } = useAddepar();
  const {
    state: {connection_ids: bridge_ids, connections: bridge_connections},
  } = useBridge();

  const [accountNumber, setAccountNumber] = useState('');

  const active_connections =
    !!institutions?.length ||
    !!connection_ids?.length ||
    !!addepar_ids?.length ||
    !!bridge_ids?.length;

  return (
    <div className="page-container">
      {linking ? (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <Spinner size={50} color={'gray'} speed={0.5} style={{top: 300}} />
        </div>
      ) : active_connections ? (
        <div>
          <div style={{margin: ''}}>
            <table>
              <thead>
                <tr>
                  <th>Data Provider</th>
                  <th>Institution</th>
                  <th>Owner</th>
                  <th>Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {institutions.map(item => {
                  return (
                    <PlaidRow
                      key={item.item_id}
                      item={item}
                      accounts={accounts}
                      navigate={navigate}
                    />
                  );
                })}
                {connection_ids.map(con_id => {
                  const conn = connections?.[con_id] ?? {};
                  const {company} = conn;

                  return (
                    <tr key={con_id}>
                      <td>BILL</td>
                      <td>{company || '—'}</td>
                      <td>—</td>
                      <td>—</td>
                      <td>
                        <button
                          style={{color: 'blue'}}
                          onClick={() => {
                            navigate(`/connections/${con_id}`);
                          }}>
                          More Info
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {addepar_ids.map(con_id => {
                  const conn = addepar_connections?.[con_id] ?? {};
                  const {entity_mappings} = conn;

                  return (
                    <tr key={con_id}>
                      <td>Addepar</td>
                      <td>—</td>
                      <td>—</td>
                      <td>{entity_mappings?.length ?? 0}</td>
                      <td>
                        <button
                          style={{color: 'blue'}}
                          onClick={() => {
                            navigate(`/addepar/${con_id}`);
                          }}>
                          More Info
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {bridge_ids.map(con_id => {
                  const conn = bridge_connections?.[con_id] ?? {};
                  const {account_mappings, custodian_mappings} = conn;
                  const advisorCode =
                    custodian_mappings?.[0]?.advisor_code || '—';
                  const bankName =
                    custodian_mappings?.[0]?.custodian || '—';
                  const activeCount =
                    account_mappings?.filter(a => !a.ignore)?.length ?? 0;

                  return (
                    <tr key={con_id}>
                      <td>BridgeFT</td>
                      <td>{bankName}</td>
                      <td>{advisorCode}</td>
                      <td>{activeCount}</td>
                      <td>
                        <button
                          style={{color: 'blue'}}
                          onClick={() => {
                            navigate(`/bridgeft/${con_id}`);
                          }}>
                          More Info
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {accountsMissingInfo?.length > 0 && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: 'black',
                opacity: 0.5,
                height: window.screen.height,
                width: window.screen.width,
                zIndex: 0,
              }}
            />
          )}
          {accountsMissingInfo?.length > 0 &&
            accountsMissingInfo.map(account => (
              <div
                style={{
                  justifyContent: 'center',
                  width: window.screen.width,
                  height: window.screen.height,
                  display: 'flex',
                }}>
                <div
                  style={{
                    height: 300,
                    width: 400,
                    marginLeft: -150,
                    alignItems: 'center',
                    opacity: 1,
                    backgroundColor: 'white',
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: -200,
                  }}>
                  <h2 style={{textAlign: 'center', fontSize: 16}}>
                    <strong>Please Confirm Account Number</strong>
                  </h2>
                  <h2 style={{marginBottom: 0, textAlign: 'center'}}>
                    {account.name}
                  </h2>
                  <TextField
                    id="confirmPassword"
                    label="Confirm Account Number (Last 4 Digits)"
                    style={{
                      background: 'white',
                      width: '80%',
                      alignSelf: 'center',
                      marginTop: 50,
                    }}
                    value={accountNumber}
                    type="text"
                    onChange={evt => {
                      if (accountNumber.length < 4) {
                        setAccountNumber(evt.target.value);
                      }
                    }}
                    variant="filled"
                    placeholder="Confirm Account Number (Last 4 Digits)"
                  />
                  {user && (
                    <button
                      onClick={() => {
                        if (user.uid) {
                          addMissingInfo(
                            user.uid,
                            account,
                            accountNumber,
                            accountsMissingInfo,
                            accounts,
                          );
                          setAccountNumber('');
                        }
                      }}
                      style={{
                        zIndex: 1,
                        backgroundColor: '#316b3b',
                        width: '150px',
                        height: '40px',
                        border: '0px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        top: 50,
                      }}>
                      <p
                        style={{
                          color: 'white',
                          fontSize: 14,
                          padding: '0px',
                          alignSelf: 'center',
                        }}>
                        Confirm
                      </p>
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div style={{textAlign: 'center'}}>
          <h3>Please Link Accounts</h3>
        </div>
      )}
    </div>
  );
}

const PlaidRow = ({item, accounts, navigate}) => {
  const {name, error, item_id} = item;
  const itemAccounts = accounts?.filter(a => a.item_id === item_id) ?? [];
  const activeAccounts = itemAccounts.filter(a => !a.disable);
  const accountOwner =
    activeAccounts.length > 0 ? activeAccounts[0].entity || '—' : '—';

  return (
    <tr key={item_id}>
      <td>Plaid</td>
      <td>{name || '—'}</td>
      <td>{accountOwner}</td>
      <td>{activeAccounts.length}</td>
      <td>
        <button
          style={{color: 'blue'}}
          onClick={() => {
            navigate(`/accounts/${item_id}`);
          }}>
          More Info
        </button>
      </td>
    </tr>
  );
};
